import React from 'react';

import { Box } from '@mui/material';
import { UserRolesEnum } from '@shared/constants/auth.constants';
import { RootState, useAppSelector } from '@shared/store';

import PostCallMessageSection from './components/PostCallMessageSection';

interface PostCallMessagesTabProps {
  campaignId: string;
  campaignName: string;
  companyName: string;
}

const PostCallMessagesTab: React.FC<PostCallMessagesTabProps> = ({
  campaignId,
  campaignName,
  companyName,
}) => {
  const currentUser = useAppSelector((state: RootState) => state.auth.authenticatedUser);

  return (
    <Box sx={{ padding: '30px', width: '100%' }}>
      <PostCallMessageSection
        campaignId={campaignId}
        campaignName={campaignName}
        companyName={companyName}
        isDisabled={currentUser?.role === UserRolesEnum.VIEWER}
      />
    </Box>
  );
};

export default PostCallMessagesTab;
